export default function log({ next, to }) {
    var segments=to.path.split("/")
    if(segments.length > 2){
      var permissions=JSON.parse(localStorage.permissions);
      var seg1=permissions.hasOwnProperty(segments[1]);
      if(seg1 && permissions.segments[1].hasOwnProperty(segments[2])){
        return next();
      }else{
        location.href='/403';
      }
    }
    return next();
  }